export const lang_EN = {
    ProductIntroduction: 'Product Introduction',
    ProductDetail: "Product Details",
    CaseDetails: "Case Details",
    // 首页
    home: 'home',
    product: 'product',
    case: 'case',
    contact: 'contact',
    home1: 'Indoor and outdoor high-definition LED screen',
    home2: 'LED Rental screen',
    home3: 'LED transparent screen',
    home4: 'LED poster',
    home5: 'LED Special-Shaped Screen',
    // 首页
    // 产品中心
    product1: 'High-definition LED  screen',
    product1_1: 'Exquisite graphics, stunning visual experience',
    prcducrt1_1_1: 'High refresh rate, high grayscale, high contrast',
    prcducrt1_1_2: 'Presents smooth and refined visual effects',
    prcducrt1_1_3: 'Takes good photos',

    product1_2: 'Efficient heat dissipation greatly extends the lifespan.',
    prcduct1_2_1: 'The enclosure is made of aluminum, which dissipates heat quickly.',
    prcduct1_2_2: 'Finned heat dissipation design increases surface area and enables faster convective cooling.',
    prcduct1_2_3: 'Slows down  aging of internal components and significantly extends service life.',

    product1_3: 'Lightweight die-castcabinet, space-saving installation, easy maintenance',
    product1_3_1: 'Module front maintenance, module maintenance of the power supply , fast and convenient',
    product1_3_2: 'Ultra-thin cabinet, wall-mounted installation, space-saving',

    product1_4: 'Supports right-angle splicing applications, bringing higher commercial value',
    product1_4_1: 'It can be adjusted to a right-angle connection according to the building structure, creating a stunning 90° corner visual effect.',
    product1_4_2: 'Perfectly matches  3D creative visuals, max value of creative marketing',

    product1_1_1_1: 'Various indoor and outdoor advertising display scenarios can all be accommodated.',
    product1_1_1_2: 'Meeting room',
    product1_1_1_3: 'Clothing store',
    product1_1_1_4: 'Shopping mall',
    product1_1_1_5: 'Museum',
    product1_1_1_6: 'Classroom',
    product1_1_1_7: 'Car shop',
    //产品2
    product2: 'LED Rental Series',

    product2_1: 'Convenient ,fast',
    product2_1_1: 'LED Special-Shaped Screen',
    product2_1_2: 'Equipped with quick locks, allowing for single-person installation.',
    product2_1_3: 'Handle coated with rubber, non-slip and comfortable to hold, easy to install.',
    //
    product2_2: 'Good flatness',
    product2_2_1: 'Integrally die-cast,  high precision  ',
    product2_2_2: 'Positioning pins allows for quick positioning ',
    //
    product2_3: 'Multiple installation , flexible forms',
    product2_3_1: 'Supports hanging and stacking, helping customers easily handle various construction environment challenges.',
    product2_3_2: 'Provide ‘’ 日’’ type  mounting solutions to help customers save more labor and material costs.',
    //
    product2_4: 'Good display effect',
    product2_4_1: 'High refresh display: >3840Hz refresh rate ',
    product2_4_2: 'Standard mask, anti-glare, enhances consistency',
    //
    product2_1_1_1: 'Various indoor and outdoor advertising display scenarios can all be accommodated.',
    product2_1_1_2: 'Outdoor commercial performance',
    product2_1_1_3: 'Outdoor commercial performance',
    product2_1_1_4: 'Concert',
    //
    product3_1: 'LED transparent screen',
    product3_1_1: 'Light, thin,  transparent',
    product3_1_2: 'Small pixel pitch ensures clarity when displayed transparently and enhances',
    product3_1_3: 'close-up viewing experience.High brightness during sunlight',

    product3_2_1: 'Modular Assembly',
    product3_2_2: 'Using modular design,install & maintain quickly ',
    //
    product3_3_1: 'Quick installation and maintenance',
    product3_3_2: 'The enclosure has built-in threaded rivets',
    product3_3_3: 'requiring only a few screws for installation',
    product3_3_4: ' convenient, and quick',
    //
    product3_1_1_1: 'Various advertising display scenarios ',
    product3_1_1_2: 'Shopping mall',
    product3_1_1_3: 'Jewelry store',
    product3_1_1_4: 'Exhibition Hall',
    product3_1_1_5: 'Restaurant',
    product3_1_1_6: 'Shopping mall',
    product3_1_1_7: 'Outdoor',
    //
    product4_1: 'Holographic Transparent Screen',
    product4_1_1: 'Transparent',
    product4_1_2: 'Using  keelless design, fully transparent and invisible effect, with a viewing clarity of over 90%.',
    product4_1_3: "Perfectly adapts to building's original design, creating transparent and natural spatial visual experience.",

    product4_2_1: 'Spatial Floating Image',
    product4_2_2: 'Naked-eye 3D floating image is displayed above the transparent glass screen, creating  immersive stereoscopic viewing experience for users.',

    product4_3_1: 'Flexible and cuttable',
    product4_3_2: 'Not limited by size or shape, adaptable to curved structures',

    product4_4_1: 'Diverse installation methods',
    product4_4_2: 'Surface Mount',
    product4_4_3: 'Vertical',
    product4_4_4: 'Hoisting',
    product4_1_1_1: "Various indoor and outdoor advertising display scenarios can all be accommodated.",

    //
    product5_1: 'LED poster',
    product5_1_1: 'Using GOB technology',
    product5_1_2: 'Surface is splash-resistant, scratch-resistant, resistant to bumps, moisture-proof, and has better stability.',

    product5_2_1: 'No installation required, ready to use once powered on',
    product5_2_2: 'The finished product is ready to ship, requires no professional installation or commissioning, and is plug-and-play.',

    product5_3_1: 'Supports multiple seamless splicing',
    product5_3_2: 'Used individually & seamless splicing of multiple units into larger screen, making its application scenarios more extensive.',

    product5_4_1: 'One-click posting on phone app',
    product5_4_2: 'Supports one-click content upload from mobile phones, user-friendly software that even beginners can operate easily.',

    product5_1_1_1: "Application Scenario Case Display",

    product6_1: 'Flexible LED Film Screen',
    product6_1_1: 'Hidden installation, highlighting technology',
    product6_1_2: 'Light, transparent, thin, and soft characteristics, applied to glass skywalk automatic doors and windows, interior partitions, commercial display windows, technology exhibition halls! In scenarios such as cultural tourism, commercial railings, and museums, sense of technology is greatly enhanced.',
    product6_2_1: 'No frame needed, display after installing',
    product6_2_2: 'The transparent thin-film screen attaches directly to the glass surface, allowing for quick and minimalist installation, saving significant costs on frames, approvals, installation, and labor.',
    product6_3_1: 'Indoor installation, outdoor view',
    product6_3_2: 'Installed indoors while achieving outdoor commercial display.',
    product6_4_1: 'Can be cut into special shapes',
    product6_4_2: 'The new favorite in light art exhibitions combines structural frameworks, invisible during the day, presenting floating images at night, becoming the eye-catching focal point.',
    product6_1_1_1: "Application Scenario Case Display",
    product6_1_1_2: "Shopping mall elevator",
    product6_1_1_3: "Building glass",
    product6_1_1_4: "Indoor glass",
    product6_1_1_5: "Exhibition Hall",
    product6_1_1_6: "Shopping mall",
    product6_1_1_7: "Shop sign",

    product7_1: 'LED cube screen',
    product7_1_1: 'Choose high-quality LED ',
    product7_1_2: "Create a high-quality display effect with ultra-high dynamic contrast, making the black-and-white contrast in the images strong and distinct, ensuring the screen's clarity and brightness.",
    product7_2_1: 'Elegant and tasteful',
    product7_3_1: 'LED cube screen',
    product7_1_1_1: "Application Scenario Case Display",
    product7_1_1_2: "Decoration",
    product7_1_1_3: "Supermarket",
    product7_1_1_4: "Shop sign",
    product7_1_1_5: "Shop sign",
    product7_1_1_6: "Decoration",
    product7_1_1_7: "Decoration",

    product8_1: 'LED round display',
    product8_1_1: 'Outdoor Round design',
    product8_1_2: 'The unique thin-frame circular design breaks limitations of traditional LED  screens, offering more possibilities for info presentation to attract clients ',
    product8_2_1: 'High-brightness; waterproof ',
    product8_2_2: 'It supports customization to any resolution, meeting various scenario needs and instantly attracting   customers ',
    product8_3_1: 'Ultra-long lifespan upgraded LED new lamp',
    product8_3_2: 'Ultra-long lifespan, high stability, vibrant colors, more realistic effects',
    product8_4_1: 'Upload creative videos with phone &laptop',
    Phone: "Phone",
    Address: "Address",
    GetQuote: "Get a Quote",
    LeaveYourInfo: "Please leave your requirements and contact information, we will contact you as soon as possible.",
    SalesPhone: "Sales Phone",
    CustomerServicePhone: "Customer Service Phone",
    Email: "Email",
    ReceptionPhone: "Reception Phone",
    Fax: "Fax",
    PostalCode: "Postal Code",
    YourName: "Your Name",
    EnterYourName: "Please enter your name",
    YourPhone: "Your Phone",
    EnterYourPhone: "Please enter your phone number",
    YourRequirements: "Your Requirements",
    EnterYourRequirements: "Enter your requirements",
    Submit: "Submit",
    MrLiu: "Mr. Liu",
    MsFan: "Ms. Fan",
    ClassicCases: "Classic Cases",
    P186FiveUnitsParallel: "P1.86 Five Units in Parallel",
    P25Indoor: "P2.5 Indoor",
    CakeShopCase: "Cake Shop Case",
    DigitalSignageCase: "Digital Signage Case",
    ClothingStoreCase: "Clothing Store Case",
    IndoorDigitalSignage3: "Indoor Digital Signage (3)",
    IndoorDigitalSignage2: "Indoor Digital Signage (2)",
    IndoorDigitalSignage: "Indoor Digital Signage",

    TianjinStageRental: "Tianjin Stage Rental",
    UKOutdoorProjectCase: "UK Outdoor Project Case",
    NantongOutdoorRentalProject: "Nantong Outdoor Rental Project",
    ShanghaiIndoorSmallPitch: "Shanghai Indoor Small Pitch",
    MeetingRoomIndoorProject: "Meeting Room Indoor Project",
    MeetingRoomSmallPitch: "Meeting Room Small Pitch",
    MeetingRoomCase: "Meeting Room Case",
    MeetingRoomProject: "Meeting Room Project",
    HospitalMeetingRoomProject: "Hospital Meeting Room Project",
    MuseumSmallPitchIndoorScreen: "Museum Small Pitch Indoor Screen",
    ShoppingMallIndoorProject: "Shopping Mall Indoor Project",
    ShoppingMallSmallPitch: "Shopping Mall Small Pitch",
    ShoppingMallOutdoorLargeScreen: "Shopping Mall Outdoor Large Screen",
    ShoppingMallClothingStore: "Shopping Mall Clothing Store",
    LEDCrystalFilmScreen: "LED Crystal Film Screen",
    ConferenceDisplayMagicCubeScreen: "Conference Display Magic Cube Screen",
    ClothingStoreLEDMagicCubeScreen: "Clothing Store LED Magic Cube Screen",
    Supermarket: "Supermarket",
    SupermarketIndoorLEDMagicCubeScreen: "Supermarket Indoor LED Magic Cube Screen",
    RestaurantLEDMagicCubeScreen: "Restaurant LED Magic Cube Screen",
    MagicCubeOfficeDisplay: "Magic Cube Office Display",
    RestaurantCase: "Restaurant Case",
    DiningCase: "Dining Case",
    CrystalFilmScreenCase: "Crystal Film Screen Case",
    ShanghaiShoppingMallProject: "Shanghai Shopping Mall Project",
    ShanghaiTowerProject: "Shanghai Tower Project",
    ShanghaiMinhangProject: "Shanghai Minhang Project",
    BaodingMuseumProject: "Baoding Museum Project",
    BeijingJewelryStoreProject: "Beijing Jewelry Store Project",
    ShoppingMallTransparentScreenCase: "Shopping Mall Transparent Screen Case",
    CommercialPerformanceProject: "Commercial Performance Project",
    RoundTransparentScreenCase: "Round Transparent Screen Case",
    SubwayStationProject: "Subway Station Project",
    NingboOutdoorProject: "Ningbo Outdoor Project",
    ShenzhenHeadquarters: "Shenzhen Headquarters",
    DongguanIntelligentManufacturingBase: "Dongguan Intelligent Manufacturing Base",
    PHONE111:'008618118700596',
    PHONE222:'008618739767975',
}